import "./product-option";

class ProductFormSelectors extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("aria-listbox:change", () =>
      this.handleInputChange(),
    );
    this.addEventListener("pdp-variant-button:updated", () => {
      this.data = window.scrapeSectionData(this);

      const variant = this.findMatchingVariant();

      if (variant) {
        this.updateGroupedProductUrls(variant);
      }
    });
  }

  disconnectedCallback() {}

  findMatchingVariant() {
    if (!this.data) {
      this.data = window.scrapeSectionData(this);
    }

    const form = this.closest("form");

    const selectedOptionValueIds = new Array(this.data.productOptionsCount)
      .fill(null)
      .map((_, i) => parseInt(form[`option-${i + 1}`]?.value, 10));

    const matchingVariant = this.data.optionsByVariant.find((variant) =>
      selectedOptionValueIds.every(
        (selectedOptionValueId, i) =>
          selectedOptionValueId === variant.variantOptions[i].id,
      ),
    );

    let variant = null;

    if (matchingVariant) {
      variant = this.data.variants.find(
        (variant) => variant.id === matchingVariant.variantId,
      );
    }

    return variant;
  }

  updateGroupedProductUrls(selectedVariant) {
    if (!this.data) {
      this.data = window.scrapeSectionData(this);
    }

    this.querySelectorAll("pdp-variant-button").forEach((variantButton) => {
      const optionIndex = parseInt(variantButton.dataset.optionIndex, 10);

      const optionsToMatch = [...selectedVariant.options];
      optionsToMatch[optionIndex] = null;

      const targetProductId = variantButton.dataset.productId;
      const targetProductVariantData =
        this.data.combinedListingProductVariantData[targetProductId];

      const similarVariant = targetProductVariantData.find((variant) =>
        variant.options.every(
          (optionValue, i) =>
            optionValue === optionsToMatch[i] || optionsToMatch[i] === null,
        ),
      );

      if (similarVariant) {
        variantButton.setAttribute("product-url", similarVariant.variant_url);
      }
    });
  }

  handleInputChange() {
    this.data = window.scrapeSectionData(this);

    const variant = this.findMatchingVariant();

    if (variant) {
      this.updateGroupedProductUrls(variant);
    }

    this.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { variant },
      }),
    );
  }
}

if (!customElements.get("product-form-selectors")) {
  customElements.define("product-form-selectors", ProductFormSelectors);
}
